/* eslint-disable no-undef */

import ReactGA from "react-ga4";

const initializeAnalytics = () => {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
};

export default initializeAnalytics;
